import type { IRemoveCampaignFromCartMutation } from "@jti/magento";
import { magento } from "@jti/magento";

import { TAGS } from "../common/tags";
import { convertApiError } from "../convertApiError";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export type RemoveLoyaltyCampaignEndpointArgs = {
  cartId: string;
};

export type RemoveLoyaltyCampaignEndpointResponse = IRemoveCampaignFromCartMutation;

export const removeLoyaltyCampaignEndpoint = (builder: LoyaltyApiBuilder) => ({
  removeLoyaltyCampaign: builder.mutation<RemoveLoyaltyCampaignEndpointResponse, RemoveLoyaltyCampaignEndpointArgs>({
    queryFn: async ({ cartId }) => {
      try {
        const data = await magento.removeCampaignFromCart(cartId);
        return { data };
      } catch (error: unknown) {
        return convertApiError(error);
      }
    },
    invalidatesTags: [TAGS.LOYALTY_POINTS, TAGS.LOYALTY_VOUCHERS],
  }),
});
